'use client'

import { Button, Cell, Checkbox } from '@vinted/web-ui'
import { useState } from 'react'

import { InformationModal } from '@marketplace-web/domain/pay-identity-kyc'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useAsset } from '@marketplace-web/shared/ui-helpers'

type Props = {
  contactInfoType: 'email' | 'number'
  name: string
  title: string
  value: boolean
  onChange: (value: boolean) => void
}

const ContactInformationPersonalCheckbox = ({
  contactInfoType,
  name,
  title,
  value,
  onChange,
}: Props) => {
  const translate = useTranslate('profile_settings')
  const translateCommon = useTranslate('common')
  const asset = useAsset('assets/kyc')
  const [isPersonalContactInfoVisible, setIsPersonalContactInfoVisible] = useState(false)

  function renderIsContactInfoPersonalTitle() {
    return (
      <span>
        <span>{title}</span>
        <Button
          inline
          styling={Button.Styling.Flat}
          size={Button.Size.Medium}
          onClick={() => {
            setIsPersonalContactInfoVisible(true)
          }}
        >
          {translateCommon('a11y.actions.learn_more')}
        </Button>
      </span>
    )
  }

  function renderInformationModal() {
    const labels = {
      title: translate(`contact_${contactInfoType}.info.title`),
      description: translate(`contact_${contactInfoType}.info.description`),
      closeButtonText: translate(`contact_${contactInfoType}.info.button`),
    }

    return (
      <InformationModal
        {...labels}
        show={isPersonalContactInfoVisible}
        iconPath={asset('lamp.svg')}
        onClose={() => setIsPersonalContactInfoVisible(false)}
      />
    )
  }

  return (
    <>
      <Cell
        styling={Cell.Styling.Wide}
        title={renderIsContactInfoPersonalTitle()}
        suffix={
          <Checkbox
            labelPosition="right"
            name={name}
            checked={value}
            onChange={event => onChange(event.target.checked)}
          />
        }
      />
      {isPersonalContactInfoVisible && renderInformationModal()}
    </>
  )
}

export default ContactInformationPersonalCheckbox
